const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const LEVEL_ORDER = { A: 0, B: 1, C: 2, D: 3, E: 4 };

function deriveTrend(campaigns) {
  if (campaigns.length < 2) return "stable";
  const last = LEVEL_ORDER[campaigns.at(-1).fused_level] ?? 0;
  const prev = LEVEL_ORDER[campaigns.at(-2).fused_level] ?? 0;
  if (last < prev) return "improving";
  if (last > prev) return "degrading";
  return "stable";
}

function deriveBinding(ctag, physical) {
  const c = LEVEL_ORDER[ctag] ?? 0;
  const p = LEVEL_ORDER[physical] ?? 0;
  if (p > c) return "physical";
  if (c > p) return "ctag";
  return null;
}

const DETAILS = {
  "N550-SEG-001": {
    ctag_level: "A",
    physical_level: "A",
    fused_level: "A",
    data_partial: false,
    signals: [
      {
        type: "weather_event",
        value: "Light rain · 1.1 mm/h",
        confidence: "medium",
        source_available: true,
      },
      {
        type: "traffic_density",
        value: "Free flow",
        confidence: "high",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "No anomaly detected",
        confidence: "high",
        source_available: true,
      },
      {
        type: "infrastructure_defect",
        value: "No defects on record",
        confidence: "high",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-07",
        date: "2025-07-10",
        fused_level: "A",
        ctag_level: "A",
        physical_level: "A",
      },
      {
        id: "C2025-11",
        date: "2025-11-15",
        fused_level: "A",
        ctag_level: "A",
        physical_level: "A",
      },
      {
        id: "C2026-02",
        date: "2026-02-20",
        fused_level: "A",
        ctag_level: "A",
        physical_level: "A",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "A",
        ctag_level: "A",
        physical_level: "A",
      },
    ],
    annotations: [],
    similar_segments: [],
  },

  "N550-SEG-002": {
    ctag_level: "B",
    physical_level: "B",
    fused_level: "B",
    data_partial: false,
    signals: [
      {
        type: "traffic_density",
        value: "Free flow",
        confidence: "high",
        source_available: true,
      },
      {
        type: "weather_event",
        value: "Moderate rain · 3.8 mm/h",
        confidence: "medium",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "No anomaly detected",
        confidence: "high",
        source_available: true,
      },
      {
        type: "infrastructure_defect",
        value: "No defects on record",
        confidence: "high",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-09",
        date: "2025-09-12",
        fused_level: "C",
        ctag_level: "B",
        physical_level: "C",
      },
      {
        id: "C2025-11",
        date: "2025-11-20",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
    ],
    annotations: [
      { type: "road_works", date: "2025-10-20", label: "Resurfacing works" },
    ],
    similar_segments: [],
  },

  "N550-SEG-003": {
    ctag_level: "A",
    physical_level: "B",
    fused_level: "B",
    data_partial: false,
    signals: [
      {
        type: "traffic_density",
        value: "Slow — approaching congestion zone",
        confidence: "medium",
        source_available: true,
      },
      {
        type: "weather_event",
        value: "Moderate rain · 4.2 mm/h",
        confidence: "medium",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "No anomaly detected",
        confidence: "high",
        source_available: true,
      },
      {
        type: "infrastructure_defect",
        value: "No defects on record",
        confidence: "high",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-09",
        date: "2025-09-12",
        fused_level: "B",
        ctag_level: "A",
        physical_level: "B",
      },
      {
        id: "C2025-11",
        date: "2025-11-20",
        fused_level: "B",
        ctag_level: "A",
        physical_level: "B",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "B",
        ctag_level: "A",
        physical_level: "B",
      },
    ],
    annotations: [],
    similar_segments: [],
  },

  "N550-SEG-004": {
    ctag_level: "B",
    physical_level: "D",
    fused_level: "C",
    data_partial: false,
    signals: [
      {
        type: "traffic_density",
        value: "Congestion detected (km 34)",
        confidence: "high",
        source_available: true,
      },
      {
        type: "infrastructure_defect",
        value: "Pavement crack cluster (AN-002)",
        confidence: "high",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "58 ms avg (↑ 12 ms vs baseline)",
        confidence: "high",
        source_available: true,
      },
      {
        type: "weather_event",
        value: "Moderate rain · 4.2 mm/h",
        confidence: "medium",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-07",
        date: "2025-07-10",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2025-09",
        date: "2025-09-15",
        fused_level: "C",
        ctag_level: "B",
        physical_level: "C",
      },
      {
        id: "C2025-11",
        date: "2025-11-20",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2026-02",
        date: "2026-02-18",
        fused_level: "C",
        ctag_level: "B",
        physical_level: "C",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "C",
        ctag_level: "B",
        physical_level: "D",
      },
    ],
    annotations: [
      { type: "heavy_rain", date: "2025-09-05", label: "Heavy rain period" },
      {
        type: "road_works",
        date: "2025-10-10",
        label: "Resurfacing works (partial)",
      },
      { type: "heavy_rain", date: "2026-02-08", label: "Heavy rain period" },
    ],
    similar_segments: [
      {
        segment_id: "N550-SEG-007",
        label: "Pontecesures",
        fused_level: "C",
        binding_constraint: "physical",
        outcome_level: "B",
      },
      {
        segment_id: "N550-SEG-011",
        label: "Pontevedra Centro",
        fused_level: "C",
        binding_constraint: "physical",
        outcome_level: "B",
      },
      {
        segment_id: "N550-SEG-013",
        label: "Redondela",
        fused_level: "C",
        binding_constraint: "physical",
        outcome_level: "B",
      },
    ],
  },

  "N550-SEG-005": {
    ctag_level: "C",
    physical_level: "E",
    fused_level: "E",
    data_partial: true,
    signals: [
      {
        type: "traffic_density",
        value: "Congestion detected (km 41–48)",
        confidence: "high",
        source_available: true,
      },
      {
        type: "infrastructure_defect",
        value: "Severe surface degradation",
        confidence: "high",
        source_available: true,
      },
      {
        type: "weather_event",
        value: "Moderate rain · 4.2 mm/h",
        confidence: "medium",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "Source unavailable",
        confidence: "low",
        source_available: false,
      },
    ],
    campaigns: [
      {
        id: "C2025-09",
        date: "2025-09-15",
        fused_level: "C",
        ctag_level: "C",
        physical_level: "C",
      },
      {
        id: "C2025-11",
        date: "2025-11-20",
        fused_level: "D",
        ctag_level: "C",
        physical_level: "D",
      },
      {
        id: "C2026-02",
        date: "2026-02-18",
        fused_level: "D",
        ctag_level: "C",
        physical_level: "D",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "E",
        ctag_level: "C",
        physical_level: "E",
      },
    ],
    annotations: [
      { type: "heavy_rain", date: "2025-11-05", label: "Heavy rain period" },
      { type: "heavy_rain", date: "2026-02-08", label: "Heavy rain period" },
    ],
    similar_segments: [
      {
        segment_id: "N550-SEG-010",
        label: "Pontevedra Norte",
        fused_level: "D",
        binding_constraint: "physical",
        outcome_level: "C",
      },
    ],
  },

  "N550-SEG-006": {
    ctag_level: "B",
    physical_level: "D",
    fused_level: "D",
    data_partial: false,
    signals: [
      {
        type: "traffic_density",
        value: "Congestion detected",
        confidence: "high",
        source_available: true,
      },
      {
        type: "weather_event",
        value: "Fog · Vis. 80 m",
        confidence: "high",
        source_available: true,
      },
      {
        type: "infrastructure_defect",
        value: "No defects on record",
        confidence: "medium",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "No anomaly detected",
        confidence: "high",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-09",
        date: "2025-09-15",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2026-02",
        date: "2026-02-18",
        fused_level: "C",
        ctag_level: "B",
        physical_level: "C",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "D",
        ctag_level: "B",
        physical_level: "D",
      },
    ],
    annotations: [
      { type: "heavy_rain", date: "2026-02-08", label: "Heavy rain period" },
    ],
    similar_segments: [
      {
        segment_id: "N550-SEG-014",
        label: "Vigo",
        fused_level: "D",
        binding_constraint: "physical",
        outcome_level: "C",
      },
    ],
  },

  "N550-SEG-007": {
    ctag_level: "B",
    physical_level: "C",
    fused_level: "C",
    data_partial: false,
    signals: [
      {
        type: "infrastructure_defect",
        value: "Rutting threshold exceeded (AN-003)",
        confidence: "high",
        source_available: true,
      },
      {
        type: "traffic_density",
        value: "Slow — adjacent to congestion zone",
        confidence: "medium",
        source_available: true,
      },
      {
        type: "weather_event",
        value: "Light rain · 1.1 mm/h",
        confidence: "medium",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "No anomaly detected",
        confidence: "high",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-07",
        date: "2025-07-10",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2025-09",
        date: "2025-09-15",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2026-02",
        date: "2026-02-18",
        fused_level: "C",
        ctag_level: "B",
        physical_level: "C",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "C",
        ctag_level: "B",
        physical_level: "C",
      },
    ],
    annotations: [
      { type: "heavy_rain", date: "2026-01-20", label: "Heavy rain period" },
    ],
    similar_segments: [
      {
        segment_id: "N550-SEG-013",
        label: "Redondela",
        fused_level: "C",
        binding_constraint: "physical",
        outcome_level: "B",
      },
    ],
  },

  "N550-SEG-008": {
    ctag_level: "A",
    physical_level: "A",
    fused_level: "A",
    data_partial: false,
    signals: [
      {
        type: "traffic_density",
        value: "Free flow",
        confidence: "high",
        source_available: true,
      },
      {
        type: "weather_event",
        value: "Cloudy · Vis. 1200 m",
        confidence: "high",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "No anomaly detected",
        confidence: "high",
        source_available: true,
      },
      {
        type: "infrastructure_defect",
        value: "No defects on record",
        confidence: "high",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-07",
        date: "2025-07-10",
        fused_level: "B",
        ctag_level: "A",
        physical_level: "B",
      },
      {
        id: "C2025-09",
        date: "2025-09-15",
        fused_level: "B",
        ctag_level: "A",
        physical_level: "B",
      },
      {
        id: "C2026-02",
        date: "2026-02-18",
        fused_level: "B",
        ctag_level: "A",
        physical_level: "B",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "A",
        ctag_level: "A",
        physical_level: "A",
      },
    ],
    annotations: [
      { type: "road_works", date: "2026-03-01", label: "Full resurfacing" },
    ],
    similar_segments: [],
  },

  "N550-SEG-009": {
    ctag_level: "B",
    physical_level: "B",
    fused_level: "B",
    data_partial: true,
    signals: [
      {
        type: "traffic_density",
        value: "Free flow",
        confidence: "high",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "No anomaly detected",
        confidence: "high",
        source_available: true,
      },
      {
        type: "weather_event",
        value: "Source unavailable",
        confidence: "low",
        source_available: false,
      },
      {
        type: "infrastructure_defect",
        value: "No defects on record",
        confidence: "high",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2026-02",
        date: "2026-02-18",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
    ],
    annotations: [],
    similar_segments: [],
  },

  "N550-SEG-010": {
    ctag_level: "D",
    physical_level: "B",
    fused_level: "D",
    data_partial: false,
    signals: [
      {
        type: "latency_anomaly",
        value: "112 ms avg (↑ 68 ms vs baseline)",
        confidence: "high",
        source_available: true,
      },
      {
        type: "traffic_density",
        value: "Free flow",
        confidence: "high",
        source_available: true,
      },
      {
        type: "weather_event",
        value: "Cloudy · Vis. 1200 m",
        confidence: "high",
        source_available: true,
      },
      {
        type: "infrastructure_defect",
        value: "No defects on record",
        confidence: "medium",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-07",
        date: "2025-07-10",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2025-09",
        date: "2025-09-15",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2026-02",
        date: "2026-02-18",
        fused_level: "C",
        ctag_level: "C",
        physical_level: "B",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "D",
        ctag_level: "D",
        physical_level: "B",
      },
    ],
    annotations: [
      { type: "operator_change", date: "2026-01-15", label: "Operator change" },
    ],
    similar_segments: [],
  },

  "N550-SEG-011": {
    ctag_level: "B",
    physical_level: "C",
    fused_level: "C",
    data_partial: false,
    signals: [
      {
        type: "latency_anomaly",
        value: "Sudden ISAD drop detected (AN-001)",
        confidence: "high",
        source_available: true,
      },
      {
        type: "infrastructure_defect",
        value: "Surface inspection pending",
        confidence: "low",
        source_available: true,
      },
      {
        type: "traffic_density",
        value: "Free flow",
        confidence: "high",
        source_available: true,
      },
      {
        type: "weather_event",
        value: "Light rain · 1.1 mm/h",
        confidence: "medium",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-07",
        date: "2025-07-10",
        fused_level: "A",
        ctag_level: "A",
        physical_level: "A",
      },
      {
        id: "C2025-09",
        date: "2025-09-15",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2025-11",
        date: "2025-11-20",
        fused_level: "A",
        ctag_level: "A",
        physical_level: "A",
      },
      {
        id: "C2026-02",
        date: "2026-02-18",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "C",
        ctag_level: "B",
        physical_level: "C",
      },
    ],
    annotations: [
      { type: "heavy_rain", date: "2025-09-05", label: "Heavy rain period" },
    ],
    similar_segments: [
      {
        segment_id: "N550-SEG-007",
        label: "Pontecesures",
        fused_level: "C",
        binding_constraint: "physical",
        outcome_level: "B",
      },
      {
        segment_id: "N550-SEG-013",
        label: "Redondela",
        fused_level: "C",
        binding_constraint: "physical",
        outcome_level: "B",
      },
    ],
  },

  "N550-SEG-012": {
    ctag_level: "B",
    physical_level: "B",
    fused_level: "B",
    data_partial: false,
    signals: [
      {
        type: "weather_event",
        value: "Fog · Vis. 90 m",
        confidence: "high",
        source_available: true,
      },
      {
        type: "traffic_density",
        value: "Free flow",
        confidence: "high",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "No anomaly detected",
        confidence: "high",
        source_available: true,
      },
      {
        type: "infrastructure_defect",
        value: "No defects on record",
        confidence: "high",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-09",
        date: "2025-09-15",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2026-02",
        date: "2026-02-18",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
    ],
    annotations: [],
    similar_segments: [],
  },

  "N550-SEG-013": {
    ctag_level: "B",
    physical_level: "B",
    fused_level: "B",
    data_partial: false,
    signals: [
      {
        type: "weather_event",
        value: "Fog · Vis. 90 m",
        confidence: "high",
        source_available: true,
      },
      {
        type: "traffic_density",
        value: "Free flow",
        confidence: "high",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "No anomaly detected",
        confidence: "high",
        source_available: true,
      },
      {
        type: "infrastructure_defect",
        value: "No defects on record",
        confidence: "high",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-09",
        date: "2025-09-15",
        fused_level: "C",
        ctag_level: "B",
        physical_level: "D",
      },
      {
        id: "C2025-11",
        date: "2025-11-20",
        fused_level: "C",
        ctag_level: "B",
        physical_level: "C",
      },
      {
        id: "C2026-02",
        date: "2026-02-18",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
    ],
    annotations: [
      { type: "road_works", date: "2025-12-01", label: "Emergency patching" },
    ],
    similar_segments: [],
  },

  "N550-SEG-014": {
    ctag_level: "B",
    physical_level: "D",
    fused_level: "D",
    data_partial: false,
    signals: [
      {
        type: "infrastructure_defect",
        value: "Drainage failure reported",
        confidence: "medium",
        source_available: true,
      },
      {
        type: "weather_event",
        value: "Fog · Vis. 80 m",
        confidence: "high",
        source_available: true,
      },
      {
        type: "traffic_density",
        value: "Free flow",
        confidence: "high",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "No anomaly detected",
        confidence: "high",
        source_available: true,
      },
    ],
    campaigns: [
      {
        id: "C2025-09",
        date: "2025-09-15",
        fused_level: "B",
        ctag_level: "B",
        physical_level: "B",
      },
      {
        id: "C2025-11",
        date: "2025-11-20",
        fused_level: "C",
        ctag_level: "B",
        physical_level: "C",
      },
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "D",
        ctag_level: "B",
        physical_level: "D",
      },
    ],
    annotations: [
      { type: "heavy_rain", date: "2026-03-10", label: "Heavy rain period" },
    ],
    similar_segments: [
      {
        segment_id: "N550-SEG-006",
        label: "Padrón — A Pobra",
        fused_level: "D",
        binding_constraint: "physical",
        outcome_level: "C",
      },
    ],
  },

  "N550-SEG-015": {
    ctag_level: "C",
    physical_level: "C",
    fused_level: "C",
    data_partial: true,
    signals: [
      {
        type: "weather_event",
        value: "Fog · Vis. 80 m",
        confidence: "high",
        source_available: true,
      },
      {
        type: "traffic_density",
        value: "Free flow",
        confidence: "high",
        source_available: true,
      },
      {
        type: "latency_anomaly",
        value: "Source unavailable",
        confidence: "low",
        source_available: false,
      },
      {
        type: "infrastructure_defect",
        value: "Source unavailable",
        confidence: "low",
        source_available: false,
      },
    ],
    campaigns: [
      {
        id: "C2026-04",
        date: "2026-04-10",
        fused_level: "C",
        ctag_level: "C",
        physical_level: "C",
      },
    ],
    annotations: [],
    similar_segments: [
      {
        segment_id: "N550-SEG-007",
        label: "Pontecesures",
        fused_level: "C",
        binding_constraint: null,
        outcome_level: "B",
      },
    ],
  },
};

export const fetchSegmentDetail = async (segmentId) => {
  await delay(350);
  const base = DETAILS[segmentId];
  if (!base) return null;
  return {
    segment_id: segmentId,
    ...base,
    binding_constraint: deriveBinding(base.ctag_level, base.physical_level),
    trend: deriveTrend(base.campaigns),
  };
};
